export default "__VITE_ASSET__CXa6ALhR__"